module.exports = __webpack_public_path__ + "static/media/IMG_2415.5107399c.jpeg";